import { createApp } from 'vue'
import { createPinia } from 'pinia'

import Buefy from 'buefy'

import CartApp from './CartApp.vue'
import gtag from '@/gtag.js'
import plugins from '@/plugins'
import router from './router.js'

import '@/assets/base.scss'
import '@/assets/lifficons.css'

const customIconConfig = {
  customIconPacks: {
    liffapp: {
      sizes: {
        default: 'is-size-5',
        'is-small': '',
        'is-medium': 'is-size-3',
        'is-large': 'is-size-1',
      },
      iconPrefix: 'icon-',
    },
  },
}

const pinia = createPinia()
const app = createApp(CartApp).use(Buefy, {
  ...customIconConfig,
})

app.use(pinia)
app.use(router)
app.use(plugins)

// Use a separate namespace for cart analytics
gtag.setup(app, router, 'lockers-cart')

app.mount('#app')
